var map = {
	"./10001.png": 4462,
	"./10002.png": 3237,
	"./10019.png": 7389,
	"./10023.png": 458,
	"./ALIPAY_CN.png": 4760,
	"./ALIPAY_HK.png": 8684,
	"./BOOST.png": 2271,
	"./GRABPAY_MY.png": 2965,
	"./GRABPAY_SG.png": 4021,
	"./JKOPAY.png": 2254,
	"./ONLINEBANKING_FPX.png": 4164,
	"./PAYNOW.png": 9978,
	"./TNG.png": 7971,
	"./VB.png": 1160,
	"./X (3).png": 4430,
	"./active.png": 4830,
	"./alert-bg.png": 3398,
	"./amount-active.png": 2393,
	"./amount.png": 6448,
	"./andriod.png": 2327,
	"./anew.png": 4157,
	"./btn-android.png": 8316,
	"./btn-bg.png": 8984,
	"./btn-ios.png": 6950,
	"./btn-pay.png": 8648,
	"./btn.png": 1814,
	"./buttonBg.png": 9237,
	"./buy.png": 3618,
	"./card1.png": 2197,
	"./card2.png": 4366,
	"./card3.png": 6244,
	"./channel.png": 9039,
	"./chiosBg.png": 8707,
	"./close.png": 9578,
	"./dlbg.png": 7185,
	"./dxz-bg.png": 1662,
	"./dxz-shade.png": 6412,
	"./fail.png": 271,
	"./frxxz-bg.png": 166,
	"./frxxz-shade.png": 7732,
	"./icon-close.png": 7308,
	"./ios.png": 2529,
	"./ischiose.png": 5745,
	"./more.png": 4331,
	"./navBg.png": 1588,
	"./nochiose.png": 4236,
	"./pay-bg.png": 7342,
	"./pay.png": 7616,
	"./payMsgBg.png": 7232,
	"./pay_fail.png": 3445,
	"./pay_success.png": 4948,
	"./paybtn.png": 5258,
	"./paymentBg-active.png": 286,
	"./paymentBg.png": 3125,
	"./pc.png": 4663,
	"./platformPay.png": 5127,
	"./pointBg.png": 2061,
	"./redMoon-bg.png": 5946,
	"./redMoon-shade.png": 3096,
	"./sel-pointBg.png": 1974,
	"./sg-bg.png": 3984,
	"./sg-shade.png": 2126,
	"./shopBg-active.png": 9334,
	"./shopBg.png": 1181,
	"./ss-bg.png": 2180,
	"./ss-shade.png": 3330,
	"./success.png": 2043,
	"./twfsb-bg.png": 8872,
	"./twfsb-shade.png": 7654,
	"./ys-bg.png": 1322,
	"./ys-shade.png": 6200
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5599;